export default class Command
{
	remoteClass = "gongqi.erp.framework.core.Command";
	classType;	//String
	className;	//String
	instanceType;	//String
	instanceId;	//String
	methodName;	//String
	argType;	//Array
	argValue;	//Array
	returnType;	//String
	
	appendArg(value, type="String")
	{
		if(this.argType==null)
			this.argType = [];

		if(this.argValue==null)
			this.argValue = [];

		this.argType.push(type);
		this.argValue.push(value);

		return this;
	}

	static create(
		classType,
		className,
		instanceType,
		instanceId,
		methodName,
		returnType)
	{
		let command = new Command();
		command.classType = classType;
		command.className = className;
		command.instanceType = instanceType;
		command.instanceId = instanceId;
		command.methodName = methodName;
		command.returnType = returnType;
		return command;
	}


	static createService(className, methodName, returnType="String")
	{
		return Command.create("service", className, null, null, methodName, returnType);
	}
		
	static createNew(className, methodName, returnType="String")
	{
		return Command.create("new", className, null, null, methodName, returnType);
	}

}


// WEBPACK FOOTER //
// ./src/remote/Command.js